import "./WhatsappButton.scss";
import { FaWhatsapp } from "react-icons/fa";

export const WhatsappButton = ({
    phoneNumber = "34600000000",
    message = "Hola, me gustaría obtener más información sobre SupplyER",
}) => {
    const handleClick = () => {
        const encodedMessage = encodeURIComponent(message);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        window.open(whatsappUrl, "_blank");
    };

    return (
        <button
            className="whatsapp-button"
            onClick={handleClick}
            aria-label="Contactar por WhatsApp"
        >
            <FaWhatsapp className="whatsapp-button__icon" />
        </button>
    );
};
